<template>
    <div v-if="show" class="modal-wrapper">
        <form class="modal" @submit.prevent="saveStep()">
            <h3>Edit Step</h3>
            <div class="modal-content">
                <div class="field columns">
                    <select v-model="step.action" class="third-column">
                        <option value="email">Send email</option>
                        <option value="switch">Switch to a different funnel</option>
                    </select>
                    <input type="number" v-model="step.delta" class="third-column">
                    <select class="third-column">
                        <option>days after being added to the campaign</option>
                    </select>
                </div>

                <template v-if="step.action === 'email'">
                    <div class="field">
                        <input v-model="message.subject" type="text" placeholder="Subject..." class="full-width">
                    </div>

                    <div class="field">
                        <textarea v-model="message.body" class="full-width tall" placeholder="Your message..."></textarea>
                    </div>
                </template>

                <template v-if="step.action === 'switch'">
                    <div class="field">
                        <label>Which funnel should be switched to?</label>
                        <select v-model="step.funnelId" class="full-width">
                            <option value="" disabled="disabled">Choose a Funnel</option>
                            <option v-for="funnel in notThisFunnel" :key="Math.random() + 'funnel-' + funnel.id" :value="funnel.id">
                                {{funnel.name}}
                            </option>
                        </select>
                    </div>
                </template>

                <div class="field">
                    <label>What is the status of this step?</label>
                    <select v-model="step.status" class="full-width">
                        <option value="draft">Draft</option>
                        <option value="publish">Published</option>
                    </select>
                </div>
            </div>
            <div class="modal-actions">
                <a @click="removeStep()" href="javascript:;" class="float-left">
                    <font-awesome-icon icon="trash" />
                </a>
                <a @click="show = false" href="javascript:;" class="cancel">Cancel</a>
                <button>Save Step</button>
            </div>
        </form>
    </div>
</template>

<script>

export default {
    props: ['app'],
    data() {
        return {
            show: false,
            internalDelta: 0,
            step: undefined,
            funnel: undefined
        };
    },
    computed: {
        message() {
            var _ = this;
            return _.step.message || {};
        },
        notThisFunnel() {
            var _ = this;
            return _.app.funnels.filter(function(funnel) {
                return funnel.id !== _.funnel.id;
            });
        }
    },
    methods: {
        saveStep() {
            var _ = this;

            _.app.requester.request({
                controller: 'funnels',
                action: 'save',
                funnel: _.funnel
            });

            _.show = false;
        },

        removeStep() {
            var _ = this;

            if (confirm('Are you sure you want to remove this step?')) {
                _.show = false;
                _.funnel.steps.splice(_.funnel.steps.indexOf(_.step), 1);
                _.saveStep();
            }
        }
    }
};
</script>
